module.exports = __webpack_public_path__ + "70b6ac53884c5066eecfe17fe6ad27d3.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/garage_thumb.jpg
// module id = 471
// module chunks = 0